import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { useCheckRoutingInfoQueryCache } from "#/components/carrot-plans/shared/useQueryRoutingInfo"
import { Journey } from "#/lib/contentful/utils/journeyOrderMapping"
import { PreservationInterest } from "#/components/carrot-plans/types/preservationInterest"

/**
 * Decision step for preservation journey routing.
 * Routes users based on their preservation interest and journey stage.
 * Special handling for PRESERVE_SPERM: routes to clinic name collection.
 */
export default function WhereAreYouInJourneyPreservationDecisionStep(): JSX.Element {
  const routingData = useCheckRoutingInfoQueryCache()
  const journeyValue = routingData?.journey
  const journeyStageValue = routingData?.journeyStage
  const preservationInterest = routingData?.preservationInterest
  const { send } = useStateMachine()

  useEffect(() => {
    // Only handle routing for preservation journeys
    if (journeyValue !== Journey.PRESERVATION) {
      send(null)
      return
    }

    if (preservationInterest === PreservationInterest.PRESERVE_SPERM) {
      send("GO_TO_CLINIC_NAME")
      return
    }

    // For other preservation interests (PRESERVE_EGGS, PRESERVE_EMBRYOS, etc.),
    // route based on journey stage value (existing behavior)
    send(journeyStageValue)
  }, [journeyValue, journeyStageValue, preservationInterest, send])

  return <></>
}
